export const Create = () => import('./Create.vue');
export const Edit = () => import('./Edit.vue');
export const List = () => import('./List.vue');
export const AddUser = () => import('./AddUser.vue');
export const AddCompany = () => import('./AddCompany.vue');
export const Assign = () => import('./Assign.vue');
export const ViewUser = () => import('./ViewUser.vue');
